import styled from "styled-components";

export const KeyboardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  max-width: 300px;
  padding: 15px;
  margin: 20px auto;
  background-color: #626166;
`;

export const KeyboardButton = styled.button`
  padding: 10px;
  font-size: 16px;
  text-align: center;
  background-color: #191A1F;
  color: white;
  border: solid 2px #000000;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:active {
    background-color: #2980b9;
    color: white;
  }
`;
